import styled from 'styled-components';

export const Container = styled.section`
  display: block;
  margin-bottom: 32px;
`;

export const Day = styled.span`
  padding: 16px 16px 0 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: ${({ theme }) => theme.expensesSelectableList.day};
`;

export const List = styled.ol`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;
